<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMRegionList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMRegionForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMRegionForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMRegionForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmregion/update/isLoading',
      error: 'excmregion/update/error',
      deleteError: 'excmregion/del/error',
      deleteLoading: 'excmregion/del/isLoading',
      created: 'excmregion/create/created',
      deleted: 'excmregion/del/deleted',
      retrieved: 'excmregion/update/retrieved',
      updated: 'excmregion/update/updated',
      violations: 'excmregion/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMRegionList' })
    },
    updated: function () {
      this.$router.push({ name: 'EXCMRegionShow', params: { id: this.updated['@id'] } })
    },
    retrieved () {
      if (this.retrieved.idCoordinator && this.retrieved.idCoordinator['@id']) {
        this.retrieved.idCoordinator = this.retrieved.idCoordinator['@id']
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmregion/create/reset',
      deleteItem: 'excmregion/del/del',
      delReset: 'excmregion/del/reset',
      retrieve: 'excmregion/update/retrieve',
      updateReset: 'excmregion/update/reset',
      update: 'excmregion/update/update',
      updateRetrieved: 'excmregion/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmregion ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.regionUserData) {
        delete this.retrieved.regionUserData
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
